import React, { useEffect } from 'react';
import {
  EmailTask,
  FileDto,
  FileType,
  useProjectDocumentsService
} from 'nekst-api';
import {
  FileUploaderWidget,
  RowRepeater
} from 'features/nekst-widgets';

import {
  ErrorsWrapper,
  List,
  SimpleBlock,
  TextLink,
  useFormContextRequired,
} from 'ui-builder';
import { FileUploaderCustomWidgetProps } from 'features/nekst-widgets';

import styles from './Attachments.module.scss';
import FilePreviewRow from './FilePreviewRow/FilePreviewRow';
import { Spacings } from 'react-native-ui-lib';

export function AttachmentsList() {
  const formContext = useFormContextRequired<EmailTask>();

  const documents = formContext.data!._attachedDocuments || [];

  if (documents.length > 0) {
    return (
      <List
        getDataFunc={async () => documents}
        dependencies={[documents.length]}
      >
        <RowRepeater style={{ gap: Spacings.s2, marginBottom: Spacings.s2 }}>
          <FilePreviewRow />
        </RowRepeater>
      </List>
    );
  } else {
    return null;
  }

}

function FileUploadLink(props: FileUploaderCustomWidgetProps) {

  let text = '+ Attach Document';

  if (props.isDisabled) {
    text = 'Uploading...';
  }

  return (
    <TextLink
      onClick={props.onClick}
      className={styles.link}
      style={{
        marginBottom: Spacings.s2
      }}
      isDisabled={props.isDisabled}
    >
      {text}
    </TextLink>
  );
}

export function AddAttachmentButton() {
  const projectDocumentsService = useProjectDocumentsService();

  const formContext = useFormContextRequired();

  const data = (formContext.data || {}) as EmailTask;

  const projectId = data.projectId;

  async function createDocument(file: FileDto) {
    const document = await projectDocumentsService.createDocument(
      projectId!,
      file.id,
    );

    formContext.onChangeCallback!({
      ...data,
      attachedDocumentsIds: [...(data.attachedDocumentsIds || []), document.id],
      _attachedDocuments: [...(data._attachedDocuments || []), document],
    });
  }

  if (projectId) {
    return (
      <FileUploaderWidget
        onFileUploaded={async (file) => {
          await createDocument(file);
        }}
        onValidationErrors={(errors) => {
          // no action
        }}
        name="attachment"
        fileType={FileType.PROJECT_DOCUMENT}
        widget={FileUploadLink}
      />
    );
  } else {
    return null;
  }
}

function AttachmentsClearer() {
  const formContext = useFormContextRequired<EmailTask>();

  const projectId = formContext.data?.projectId;

  const [init, setInit] = React.useState(false);

  useEffect(() => {
    if (!init) {
      setInit(true);
    } else {
      formContext.onChangeCallback!({
        attachedDocumentsIds: [],
        _attachedDocuments: [],
      });
    }
  }, [projectId]);

  return null;
}

export function AttachmentsWidget() {
  return (
    <ErrorsWrapper name="attachedDocumentsIds">
      <SimpleBlock>
        <AttachmentsClearer />
        <AttachmentsList />
        <AddAttachmentButton />
      </SimpleBlock>
    </ErrorsWrapper>
  );
}
